import { Box, Flex, Heading, Text, useColorMode } from "@chakra-ui/react";
import Form from "../Form/Form";
import { getCurrentColor } from "../../constants";
const MainPageForm = () => {
  const { colorMode } = useColorMode();
  return (
    <Flex
      flexDirection={"column"}
      maxW={"530px"}
      w={"100%"}
      p={6}
      boxShadow="xl"
      borderRadius="lg"
      bg={getCurrentColor(colorMode, "whiteC.100", "gray.800")}
      position={"relative"}
      overflow={"hidden"}
    >
      <>
        <Box
          position="absolute"
          top="0"
          right="0"
          w={40}
          h={40}
          bgGradient="linear(to-br, blue.500, purple.600)"
          borderRadius="full"
          opacity={0.2}
          transform="translateY(-50%) translateX(50%)"
          filter={"blur(30px)"}
        />
        <Box
          position="absolute"
          bottom="0"
          left="0"
          w={40}
          h={40}
          bgGradient="linear(to-tr, blue.600, cyan.400)"
          borderRadius="full"
          opacity={0.2}
          transform="translateY(50%) translateX(-50%)"
          filter={"blur(30px)"}
        />
      </>

      <Heading
        textAlign={"start"}
        fontSize={{ base: "25px", md: "3xl" }}
        fontFamily={"mainFont"}
        fontWeight={"600"}
        color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
      >
        Contact Us
      </Heading>
      <Text
        textAlign={"start"}
        mb={"25px"}
        fontFamily={"mainFont"}
        fontWeight={"400"}
        color={"blueC.100"}
        fontSize={{ base: "", md: "sm" }}
      >
        Have questions? Get in touch with our team.
      </Text>
      <Box w={"100%"} mx={"auto"}>
        <Form />
      </Box>
    </Flex>
  );
};

export default MainPageForm;
